import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { dynamicRoutes } from '../../../../constants/routes'

interface EditProps {
    stampDocId: string
}

const Edit: FC<EditProps> = ({ stampDocId }) => {
    return (
        <Link to={dynamicRoutes.equipmentStamp(stampDocId)}>
            <Button
                size={'small'}
                icon={<EditOutlined />}
                color='primary'
                variant='outlined'
                title={'Редактировать штамп'}
            />
        </Link>
    )
}

export default Edit
